import { getContext } from 'ol/webgl'

let cached = null

/**
 * Whether this browser can create a WebGL context.
 *
 * OL builds a WebGL layer's renderer lazily on the first render frame, so on
 * a browser without WebGL (driver blocklist, hardware acceleration off) the
 * layer constructor succeeds and the failure surfaces later, inside the
 * map's animation loop — outside any try/catch around construction — and
 * white-screens the entire map. Probe up front with OL's own context
 * factory (same context ids and attributes the renderer will request) and
 * choose canvas layers instead.
 */
export const isWebGLSupported = () => {
  if (cached === null) {
    try {
      cached = getContext(document.createElement('canvas')) !== null
    } catch {
      cached = false
    }
  }
  return cached
}
